import React from "react";
import { useTranslation } from "react-i18next";
import { MdUnfoldLess, MdUnfoldMore } from "react-icons/md";

// "Show all services" / "Collapse all services" for the carrier and account lists.
const ExpandAllButton = ({ expanded, onClick, disabled }) => {
  const { t } = useTranslation("settings");
  const Icon = expanded ? MdUnfoldLess : MdUnfoldMore;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex h-[30px] items-center gap-[5px] rounded-lg border border-ui-border bg-ui-surface px-3 text-xs font-medium text-brand transition-colors hover:border-brand hover:bg-brand-light disabled:cursor-not-allowed disabled:opacity-60"
    >
      <Icon className="h-4 w-4" />
      {expanded ? t("carriers.collapseAll") : t("carriers.showAll")}
    </button>
  );
};

export default ExpandAllButton;
